import React, {
    useEffect, useCallback, useState, useContext
} from 'react'
import { ImageType } from '../interface-type'
import { useCallbackLastObjectA } from "./use-andaman";
import { MainContext } from "../context/main-context";
import { getValFromPath, jsonParse } from './use-func/util'
import { getImageDimensions } from './use-func/util'

const Image = (props: ImageType) => {
    const { hostA, tokenA } = useContext(MainContext)
    const getLasted = useCallbackLastObjectA
    const [state, setstate] = useState<{ data: any, dimension: any, }>({ data: '', dimension: { width: 0, height: 0 } })
    const genSize = (w: number, h: number) => {
        if (w && h) {
            if (w < h) {
                return { width: w, height: w * (state.dimension.height / state.dimension.width) }
            } else if (w > h) {
                return { width: h * (state.dimension.width / state.dimension.height), height: h }
            } else {
                return { width: w, height: h }
            }
        } else {
            return { width: 0, height: 0 }
        }
    }

    const loadData = useCallback(
        async () => {
            const size: any = await getImageDimensions(props.src)
            setstate({ data: props.src, dimension: { width: size.w, height: size.h } })
        },
        [props.src],
    )

    useEffect(() => {
        if (props.src) {
            loadData()
        }
    }, [props.src])

    const updateDataWithEvent = useCallback(
        async (message: any) => {
            const payloadJson = jsonParse(message.payloadString)
            if (payloadJson && payloadJson.storage === `${props.setting.vo}.${props.setting.storage}`) {
                const lastData = await getLasted(props.host ? props.host : hostA, props.token ? props.token : tokenA, props.setting.vo, payloadJson.storage, 1)
                if (Array.isArray(lastData)) {
                    const newImage = `data:image/jpeg;base64, ${getValFromPath(lastData[0], `${props.setting.path}.${props.setting.name}`)}`
                    const size: any = await getImageDimensions(newImage)
                    setstate({ data: newImage, dimension: { width: size.w, height: size.h } })
                }
            }
        },
        [],
    )

    useEffect(() => {
        if (props.event) {
            updateDataWithEvent(props.event.message)
        }
        return () => {

        };
    }, [props.event, updateDataWithEvent])


    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={state.data} alt='' style={genSize(props.width, props.height)} />
            </div>
        </div>
    )
}

Image.defaultProps = {
    streaming: false,
    setting: null,
    width: 500,
    height: 400,
    event: null
}

export default Image
